import { DataCache } from '@shared/commons/DataCache';
export class InstrumentGroupsRiskPlan {
    get superGroupId() {
        return this._superGroupId;
    }
    get groupId() {
        return this._riskPlanDataKey.InstrumentGroupId;
    }
    get routeId() {
        return this._riskPlanDataKey.Route;
    }
    get isSuperGroup() {
        return this._childGroups.length > 0;
    }
    get itemsByProductType() {
        return this._riskPlanItems;
    }
    get childGroups() {
        return this._childGroups;
    }
    constructor(superGroupId, riskPlanDataKey, riskPlanItems) {
        this._riskPlanItems = new Map();
        this._childGroups = [];
        this._superGroupId = superGroupId;
        this._riskPlanDataKey = riskPlanDataKey;
        this._riskPlanItems = riskPlanItems;
    }
    addChildGroup(childGroup) {
        this._childGroups.push(childGroup);
    }
}
export class RiskPlanHelper {
    createInstrumentGroupsRiskPlanByMarginType(riskPlan, marginType) {
        const allGroupItems = this.getAllRiskPlanData(riskPlan, marginType);
        const allInstrumentGroupItems = [];
        for (const [key, itemsByProductType] of allGroupItems) {
            const dataKey = JSON.parse(key);
            const instrumentGroup = DataCache.getInstrumentTypeById(dataKey.InstrumentGroupId);
            if (instrumentGroup == null)
                continue;
            const instrumentGroupsRiskPlan = new InstrumentGroupsRiskPlan(instrumentGroup.SuperTypeId, dataKey, itemsByProductType);
            allInstrumentGroupItems.push(instrumentGroupsRiskPlan);
        }
        const mergedInstrumentGroupItems = Array.from(allInstrumentGroupItems);
        for (let i = 0; i < allInstrumentGroupItems.length - 1; i++) {
            const item = allInstrumentGroupItems[i];
            if (item.superGroupId == -1) {
                continue;
            }
            const superGroupItem = allInstrumentGroupItems.find((x) => x.groupId == item.superGroupId);
            if (superGroupItem != null) {
                superGroupItem.addChildGroup(item);
                mergedInstrumentGroupItems.splice(mergedInstrumentGroupItems.indexOf(item), 1);
            }
        }
        return mergedInstrumentGroupItems;
    }
    findRiskPlanItem(riskPlan, marginType, routeId, instrumentGroupId, productType) {
        const riskPlanDataDictionary = riskPlan.riskPlanCache.riskPlanDataDictionary;
        for (const [key, riskPlanSettings] of riskPlanDataDictionary) {
            const dataKey = JSON.parse(key);
            if (dataKey.Route !== routeId || dataKey.InstrumentGroupId !== instrumentGroupId) {
                continue;
            }
            const availableProductTypes = riskPlanSettings.availableProductTypes;
            for (let i = 0; i < availableProductTypes.length; i++) {
                const availableProductType = availableProductTypes[i];
                if (availableProductType !== productType) {
                    continue;
                }
                const item = riskPlanSettings.cache[productType];
                if (item.CalculateMarginType !== marginType) {
                    continue;
                }
                return item;
            }
        }
        return null;
    }
    getAllRiskPlanData(riskPlan, marginType) {
        const allRiskPlanData = new Map();
        const riskPlanDataDictionary = riskPlan.riskPlanCache.riskPlanDataDictionary;
        for (const [key, riskPlanSettings] of riskPlanDataDictionary) {
            const dataKey = JSON.parse(key);
            if (dataKey.InstrumentGroupId == null) {
                continue;
            }
            const availableProductTypes = riskPlanSettings.availableProductTypes;
            for (let i = 0; i < availableProductTypes.length; i++) {
                const availableProductType = availableProductTypes[i];
                const item = riskPlanSettings.cache[availableProductType];
                if (item.CalculateMarginType !== marginType) {
                    continue;
                }
                let keyItems = allRiskPlanData.get(key);
                if (keyItems == null) {
                    keyItems = new Map();
                    allRiskPlanData.set(key, keyItems);
                }
                keyItems.set(availableProductType, item);
            }
        }
        return allRiskPlanData;
    }
}
